import { render, staticRenderFns } from "./edit_category.vue?vue&type=template&id=7d51fd43&scoped=true"
import script from "./edit_category.vue?vue&type=script&lang=js"
export * from "./edit_category.vue?vue&type=script&lang=js"
import style0 from "./edit_category.vue?vue&type=style&index=0&id=7d51fd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d51fd43",
  null
  
)

export default component.exports